{
  "version": 1,
  "asset_id": "572449c5-65ae-453c-9c29-8cc403d7a7f1",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/572449c5-65ae-453c-9c29-8cc403d7a7f1/destination-roofing-crew-citrus-county-fl-640.avif",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/572449c5-65ae-453c-9c29-8cc403d7a7f1/destination-roofing-crew-citrus-county-fl-640.avif",
  "original_filename": "destination-roofing-crew-citrus-county-fl-640.avif",
  "size": 19254,
  "content_type": "image/avif",
  "created_at": "2026-07-21T15:42:33Z"
}
